import { configureStore } from "@reduxjs/toolkit";
import {overlayLoaderSlice} from "./common-slice";
import {navSlice,overviewSlice,schedulerSlice} from "./shift-slice"
import { paramSlice } from "./common-slice";
import { authSlice } from "../../../shared/slices";

export const store = configureStore({
  reducer: {
    authReducer: authSlice,
    overLayLoading: overlayLoaderSlice,
    navReducer:navSlice,
    paramReducer:paramSlice,
    overviewReducer:overviewSlice,
    schedulerReducer:schedulerSlice
  },
});

// export type RootState = ReturnType<typeof store.getState>;
// export type AppDispatch = typeof store.dispatch
